import React from 'react'
import strings from 'utils/strings'
import { classNames } from 'utils/utils'
import { Badge } from 'components/patterns'
import 'styles/Badge.css'

const LeadBadge = ({ className }) => (
  <Badge
    className={classNames(className, 'badge')}
    type="default"
    text={strings.lead}
  />
)

export default LeadBadge
